import { notification } from 'antd';
import { NotificationInstance } from 'antd/es/notification/interface';
import { createContext, ReactNode, useContext } from 'react';

const context = createContext<NotificationInstance | null>(null);

export function NotificationProvider({ children }: { children: ReactNode }) {
  const [api, contextHolder] = notification.useNotification();
  return (
    <context.Provider value={api}>
      {children}
      {contextHolder}
    </context.Provider>
  );
}

export const useNotification = () => useContext(context) as NotificationInstance;
